export default function authHeader() {
  const user = JSON.parse(localStorage.getItem('user'));
  //console.log(user.accessToken);
  if (user && user.accessToken) {
    return {
   // 'Content-Type': 'application/x-www-form-urlencoded', 
    'Authorization': 'Bearer ' + user.accessToken
    }; // for Spring Boot back-end
    //return { 'x-access-token': user.accessToken };       // for Node.js Express back-end
  } else {
    return {};
  }
}


